import { render, staticRenderFns } from "./BaseInformationModal.vue?vue&type=template&id=c1db1a26&scoped=true"
import script from "./BaseInformationModal.vue?vue&type=script&lang=js"
export * from "./BaseInformationModal.vue?vue&type=script&lang=js"
import style0 from "./BaseInformationModal.vue?vue&type=style&index=0&id=c1db1a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1db1a26",
  null
  
)

export default component.exports